import { ApiError } from "./ApiError";

export class NotFoundException extends ApiError {

}